import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { ttt } from '@xingternal/malt-tracking';

import { MainList } from './main-list';
import { MoreMenu } from './more-menu';

import styles from './bottom-bar.css';

const BottomBar = ({ browserBarOpen }) => {
  const [show, setShow] = useState(false);
  const toggleMenu = (show) => {
    setShow(show);

    ttt.event('PropTrackAction', {
      PropTrackAction: 'navigation_more',
      PropActionOrigin: 'navigation_no_badge',
    });
  };

  return (
    <React.Fragment>
      <MoreMenu show={show} onOutsideClick={() => toggleMenu(false)} />
      {show ? null : (
        <div
          className={cx(styles.container, {
            [styles.containerHidden]: browserBarOpen,
            [styles.onFront]: show,
          })}
        >
          <nav className={styles.bottomBar} key="main">
            <MainList toggleMenu={() => toggleMenu(true)} />
          </nav>
        </div>
      )}
    </React.Fragment>
  );
};

BottomBar.defaultProps = {
  browserBarOpen: false,
};

BottomBar.propTypes = {
  browserBarOpen: PropTypes.bool,
};

export { BottomBar };
